import React from 'react'
import _ from 'lodash'
import { Segment, Icon, Button, Header, Form, Modal } from 'semantic-ui-react'

import firebase from '../../../config/firebase'

import ChoiceForm from './choiceForm'

export default class ItemOptionForm extends React.PureComponent {
  state = {
    label: '',
    loading: false,
    name: '',
    isRequired: false,
    isSuffix: false,
    isPrefix: false,
    maxChoice: 1,
    choices: [],
    defaultChoice: null,
  }

  btnSubmitRef = React.createRef()

  componentDidMount() {
    const { action, itemOption } = this.props

    if (action === 'new') {
      this.setState(this.initItemOption())

    } else {
      const choices = _.map(itemOption.choices, (choice, choiceId) => ({ ...choice, id: choiceId }))
      const sortedChoices = _.sortBy(choices, 'order')

      this.setState({
        label: `Edit ${itemOption.name}`,
        name: itemOption.name,
        isRequired: itemOption.is_required,
        isPrefix: itemOption.is_prefix || false,
        isSuffix: itemOption.is_suffix || false,
        maxChoice: itemOption.max_choice,
        choices: sortedChoices,
        defaultChoice: sortedChoices.findIndex(choice => choice.id === itemOption.default_choice),
      })
    }
  }

  initItemOption = () => {
    const choices = [{}, {}, {}]

    return { label: 'New Option', choices, lastSortNumber: 2 }
  }

  setStateAsync = (state) => new Promise(resolve => {
    this.setState(state, resolve)
  })

  onNewChoiceClick = () => {
    const { choices } = this.state

    this.setState({ choices: choices.concat({}) })
  }

  onChoiceChange = (choice, index) => {
    const { choices } = this.state
    const choiceArray = Array.from(choices)
    choiceArray[Number(index)] = choice

    this.setState({ choices: choiceArray })
  }

  onPrefixSuffixChange = type => {
    const { isSuffix, isPrefix } = this.state

    if (type === 'suffix') {
      this.setState({
        isSuffix: !isSuffix,
        isPrefix: false
      })
    } else {
      this.setState({
        isPrefix: !isPrefix,
        isSuffix: false
      })
    }
  }

  onSave = async e => {
    e.preventDefault()

    const { onClose, storeId, itemOption } = this.props
    const { name, isRequired, maxChoice, choices, defaultChoice, isPrefix, isSuffix } = this.state
    const collection = firebase.firestore().collection('item_options')
    const itemOptionDoc = itemOption ? collection.doc(itemOption.id) : collection.doc()
    const formattedChoices = {}
    let defaultChoiceId = null

    if (isRequired && defaultChoice === null) {
      return alert('Please choose default value')
    }

    _.forEach(choices, (choice, index) => {
      const { id, ...choiceData } = choice
      let choiceId = id

      if (!choiceId) {
        choiceId = itemOptionDoc.collection('choices').doc().id
      }

      if (defaultChoice === index) {
        defaultChoiceId = choiceId
      }

      formattedChoices[choiceId] = { ...choiceData, order: index }
    })

    const keywords = _.map(choices, 'name').concat(name)
    const data = {
      name,
      store_id: storeId,
      is_required: isRequired,
      choices: formattedChoices,
      max_choice: Number(maxChoice),
      is_multiple: maxChoice > 1,
      is_suffix: isSuffix,
      is_prefix: isPrefix,
      default_choice: defaultChoiceId,
      keywords: keywords.map(keyword => keyword.toLowerCase()),
    }

    await this.setStateAsync({ loading: true })

    await itemOptionDoc.set(data)

    await this.setStateAsync({
      loading: false,
      name: '',
      isRequired: false,
      maxChoice: 1,
      ...this.initItemOption()
    })

    onClose()
  }

  onSaveClick = () => {
    this.btnSubmitRef.click()
  }

  onDefaultChange = index => {
    this.setState(prevState => ({
      defaultChoice: prevState.defaultChoice === index ? null : index
    }))
  }

  render() {
    const { label, loading, name, isRequired, maxChoice, choices, defaultChoice, isSuffix, isPrefix } = this.state
    const { onClose, visible } = this.props

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header content={label} />
        <Modal.Content style={{ height: 500, overflow: 'auto' }} className="branch-form">
          <Form disabled={loading} onSubmit={this.onSave}>
            <Form.Group widths="equal">
              <Form.Input
                fluid
                label='Name'
                placeholder='e.g Topping'
                required
                onChange={e => this.setState({ name: e.target.value })}
                value={name}
              />
              <Form.Input
                fluid
                label='Max Choice'
                placeholder='e.g 2'
                type="number"
                min={1}
                step={1}
                required
                onChange={e => this.setState({ maxChoice: e.target.value })}
                value={maxChoice}
              />
            </Form.Group>
            <Form.Group widths="equal" style={{ padding: '0px 7px' }}>
              <Form.Field>
                <Button.Group size="mini">
                  <Button as='a' onClick={() => this.setState({ isRequired: false })} positive={!isRequired}>Optional</Button>
                  <Button.Or />
                  <Button as='a' onClick={() => this.setState({ isRequired: true })} positive={isRequired}>Required</Button>
                </Button.Group>
              </Form.Field>
              <Form.Field>
                <Button.Group size="mini">
                  <Button as='a' onClick={() => this.onPrefixSuffixChange('prefix')} positive={isPrefix}>Prefix</Button>
                  <Button.Or />
                  <Button as='a' onClick={() => this.onPrefixSuffixChange('suffix')} positive={isSuffix}>Suffix</Button>
                </Button.Group>
              </Form.Field>
            </Form.Group>
            <Segment color="black" style={{ marginTop: 10 }}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                <Header>Choices</Header>
                <div>
                  <Button as='a' icon='add' onClick={this.onNewChoiceClick} />
                </div>
              </div>
              {
                _.map(choices, (choice, index) => {
                  return (
                  <ChoiceForm
                    isDefault={index === defaultChoice}
                    key={index}
                    choice={choice}
                    onChange={nextChoice => this.onChoiceChange(nextChoice, index)}
                    onRemove={() => this.setState({ choices: choices.filter((_choice, choiceIndex) => index !== choiceIndex)})}
                    onDefaultChange={() => this.onDefaultChange(index)}
                  />
                )})
              }
            </Segment>
            <button hidden type="submit" ref={ref => { this.btnSubmitRef = ref }} />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
          </Button>
          <Button
            icon
            onClick={this.onSaveClick}
            color="black"
            loading={loading}
            disabled={loading}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/itemOptionForm.js